<template>
  <div>
    <div v-if="load" class="loading">
      <img src="../assets/imgs/loading.gif" alt="" width="150" />
      <!-- Loading -->
    </div>
    <div class="card">
      <div class="card-title">防伪验证</div>
      <div class="card-cont">
        <img src="../assets/imgs/icon.png" alt="" class="img">
        <div class="card-cont-flex" v-if="resultData.quantity > companyData.scanCodeTimes">
          <p class="parse-font" >您好，您所查询的防伪码当前为第<span>{{ resultData.quantity }}</span>次查询，请谨防假冒!如有疑问；请联系厂家。</p>
          <p>防伪码：{{ this.data.code }}</p>
        </div>
        <div class="card-cont-flex" v-else>
          <p class="parse-font">您好！您所查询的是正品产品，请放心使用，感谢您的大力支持！首次查询时间:{{ resultData.createTime }}，当前第{{ resultData.quantity }}次查询</p>
          <p>防伪码：{{ this.data.code }}</p>
        </div>
      </div>
    </div>
    <div class="card">
      <template v-if="proData.shareFileList">
        <div v-for="(item,index) in proData.shareFileList" :key="index">
          <img :src="item.fileUrl" alt="" class="image" />
        </div>
      </template>
      <div class="pro_info" v-if="proData.productName">
        产品名称：{{ proData.productName ? proData.productName : '暂无' }}
      </div>
      <div class="pro_info" v-if="proData.specifications">
        产品规格：{{ proData.specifications ? proData.specifications : '暂无' }}
      </div>
      <div class="pro_info" v-if="companyData.name">
        公司名称：{{ companyData.name ? companyData.name : '暂无' }}
      </div>
      <div class="pro_info" v-if="companyData.manufacturer">
        生产厂家：{{ companyData.manufacturer ? companyData.manufacturer : '暂无' }}
      </div>
      <div class="pro_info" v-if="companyData.client">
        委托方：{{ companyData.client ? companyData.client : '暂无' }}
      </div>
      <!-- <img src="../assets/imgs/img1.jpg" class="image"> -->
    </div>
  </div>
</template>

<script>
import axios from '../utils/axios'
export default {
  props: ['data'],
  data(){
    return {
      load: false,
      resultData: '',
      proData: '', // 产品信息
      companyData: '', // 公司信息
    }
  },
  created(){
    this.load = true
    this.getData(this.data.code)
  },
  methods: {
    getData(code){
      axios.get('/system/electronicAntiCounterfeiting/queryAllByCode', { params:{code:code}} ).then((res)=>{
        if(res.code == 200){
          this.load = false
          this.resultData = res.data
          this.proData = res.data.electronicAntiProduct
          this.companyData = res.data.electronicAntiCompanyConfiguration
          document.title = res.data.electronicAntiProduct.productName
        }else{
          this.load = false
        }
      })
    }
  }
}
</script>
<style scoped>
.loading{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#fff;
  font-family: NotoSans;
  font-style: italic;
  font-size: 16px;
}
.card{
  border-radius: 8px;
  overflow: hidden;
  margin: 12px;
  background: #fff;
  padding: 12px;
  word-break: break-all;
  font-family: Avenir,Helvetica,Arial,sans-serif;
}
.card .card-title{
  font-size: 15px;
  font-weight: 700;
}
.card .card-cont{
  display: flex;
  align-items: center;
  margin-top: 14px;
  font-size: 13px;
  color: #2c3e50;
}
.card .card-cont .img{
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  margin-right: 12px;
}
.card .card-cont .card-cont-flex{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}
.card .card-cont .card-cont-flex p{
  line-height: 20px;
}
.parse-font{
  font-size: 14px;
  margin-bottom: 5px;
}
.image{
  display: block;
  width: 100%;
}
.pro_info{
  font-size: 14px;
  color: #4d4d4d;
  margin-top: 15px;
  text-align: left;
  border: 1px solid #8f8f8f;
  border-radius: 8px;
  padding: 10px;
}
</style>